import { useState } from 'react';
import chunk from '../helpers/chunk';

const usePagination = (items, limit = 2) => {
	const paginatedItems = chunk(items, limit);
	const [currentPage, setCurrentPage] = useState(0);
	const [visibleItems, setVisibleItems] = useState(paginatedItems[currentPage]);

	const handleSetPage = () => {
		setVisibleItems([...visibleItems, ...paginatedItems[currentPage + 1]]);

		if (currentPage < paginatedItems.length) {
			setCurrentPage(currentPage + 1);
		}
	};

	return {
		currentPage,
		handleSetPage,
		pageCount: paginatedItems.length - 1,
		items: visibleItems
	};
};

export default usePagination;
